module.exports = __webpack_public_path__ + "img/room4.fb13ea51.png";